export default __webpack_public_path__ + "static/media/warning--falling-rocks-or-debris-right--g1.e3a61a97.png";